{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Tüm Seçenekleri Gör",
  "Spoiler_Reveal_Tooltip": "Açmak için tıklayın",
  "VerticalEmbed_Event_Error_Subtitle": "Bu etkinlik silindi. Başka bir etkinlikle değiştirin.",
  "Viewer_Toolbar_Twitter_Tooltip": "Bunu tweetle",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Öge daraltıldı",
  "Spoiler_Reveal_Video_CTA": "Videoyu Göster",
  "VerticalEmbed_Pricing_Plan": "Sadece plan",
  "Image_Expand_Button_AriaLabel": "Görüntüyü Genişlet",
  "VerticalEmbed_From_Price": "Başlangıç ücreti",
  "Poll_Viewer_ShowAllResults_CTA": "Tüm Sonuçları Göster",
  "Spoiler_Reveal_Image_Placeholder": "Bu görüntü, spoiler içerir",
  "VerticalEmbed_Ribbon": "İndirim",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Arama kaydırıcısı",
  "VerticalEmbed_Error_Subtitle": "Bu öge silindi, başka bir öge ile değiştirin.",
  "Poll_Viewer_Multiselect_Footer": "Birden fazla cevap için oy verebilirsiniz.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Daha fazla ses kontrolü göster",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Hizmet yüklenemedi",
  "Fullscreen_Close_Button_AriaLabel": "Kapat",
  "VerticalEmbed_Event_Fetch_Error_Title": "Etkinlik yüklenemedi",
  "UploadFile_Viewer_Loader": "{{fileType}} yükleniyor",
  "Polls_Plugin_User_Avatar_Alt": "Kullanıcı avatarı",
  "Preview_ReadMore_Label": "Daha Fazla Bilgi",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Ürün yüklenemedi",
  "Fullscreen_Shrink_Button_AriaLabel": "Küçül",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Ses",
  "Spoiler_Reveal_Gallery_Placeholder": "Bu galeri, spoiler içerir",
  "Fullscreen_Expand_Button_AriaLabel": "Genişlet",
  "VerticalEmbed_Bookings_Button": "Yer Ayırt",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Sesi Aç",
  "Spoiler_Reveal_Gallery_CTA": "Galeriyi Göster",
  "Poll_Viewer_ShowLess_CTA": "Daha Az Göster",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Sessize Al",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonim",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Takip Et",
  "VerticalEmbed_Products_Button": "Satın Al",
  "Poll_Viewer_Toast_Error_ServerDown": "Sunucuya bağlanılamadı. Daha sonra tekrar deneyin.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} kişi bu cevap için oy verdi",
  "Poll_Viewer_VoteCount": "{{number}} oy",
  "VerticalEmbed_Events_Button": "Hemen Kaydol",
  "Spoiler_Reveal_Image_CTA": "Görüntüyü Göster",
  "Poll_Viewer_Toast_Error_Connection": "İnternet yok. Bağlantınızı kontrol edin.",
  "Poll_Viewer_Visibility_Owner_Footer": "Sonuçları sadece siz görebilirsiniz.",
  "VerticalEmbed_Booking_Error_Title": "Hizmet silindi.",
  "VerticalEmbed_Product_Error_Title": "Ürün silindi",
  "VerticalEmbed_Fetch_Error_Subtitle": "Öge bilgileri yüklenemedi.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} kişi bu yanıt için oy verdi",
  "VerticalEmbed_Event_Error_Title": "Etkinlik silindi.",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Öge genişletildi",
  "Audio_Plugin_Cover_Alt": "Ses dosyası kapağı",
  "Spoiler_Reveal_Video_Placeholder": "Bu video, spoiler içerir",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Teknik bir sorun oluştu. Bağlantınızı kontrol edin veya tekrar deneyin.",
  "VerticalEmbed_Fetch_Error_Title": "Öge yüklenemedi",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "Bu ürün silindi. Başka bir ürünle değiştirin.",
  "VerticalEmbed_Booking_Error_Subtitle": "Bu hizmet silindi, başka bir hizmetle değiştirin.",
  "Preview_SeeFullPost_Label": "Tamamını görüntüle",
  "UploadFile_Viewer_Download": "{{fileType}} dosyasını indir",
  "VerticalEmbed_Units_Hour": "{{hours}} sa.",
  "VerticalEmbed_Units_Minute": "{{minutes}} dk.",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Teknik bir sorun oluştu. Bağlantınızı kontrol edin veya tekrar deneyin.",
  "VerticalEmbed_Error_Button": "Değiştir",
  "VerticalEmbed_Error_Title": "Öge silindi",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Teknik bir sorun oluştu. Bağlantınızı kontrol edin veya tekrar deneyin.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
